import React from 'react'
import { AllOrderDetails, OrderStage } from '../types'
import StepProgressBar from 'components/OrdersComponents/StepProgressBar/StepProgressBar'

type Props = {
  order: AllOrderDetails;
  currentStageIndex: number;
  stage: OrderStage;
  onViewOrderClick: () => void
};


const LessOrderDetails = ({ order, currentStageIndex, stage, onViewOrderClick }: Props) => {
  return (
    <div className="space-y-4">
      <h2 className="font-bold text-3xl">{order.restaurant_name}</h2>
      <div className="flex justify-between">
        <div>{order.completion_estimate}</div>
        <div className="text-blue-500 text-2xl font-bold underline cursor-pointer" onClick={() => onViewOrderClick()}>{order.id}</div>
      </div>
      <h2 className="font-bold text-4xl">{stage?.StageName}</h2>
      <div dangerouslySetInnerHTML={{ __html: stage?.StageDescription }} />

      <div className="mx-4">
        <StepProgressBar
          currentIndex={
            order.is_completed || order.is_rejected
              ? (order.stages.length - 1) * 2
              : currentStageIndex * 2 + 1
          }
          stepLength={(order.stages.length - 1) * 2}
          className="md:!mb-12"
          steps={order.stages.map((stage) => ({
            iconColor: stage.StageColor,
            icon: stage.StageIcon,
            iconText: stage.StageName,
            isExecuted: stage.IsExecuted
          }))}
        />
      </div>
    </div>
  )
}

export default LessOrderDetails
